import { Component, inject } from '@angular/core';
import { EventCategoryService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  EventCategoryCreateDto,
  EventCategoryDto,
  EventCategoryExcelDownloadDto,
  EventCategoryUpdateDto,
} from '../proxy/controlling/dtos/event-category';
import { EVENTCATEGORY_CONFIG, EVENTCATEGORY_FIELDS } from './event-category.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-event-category',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, EventCategoryService, ConfirmationService],
  templateUrl: './event-category.html',
  styleUrl: './event-category.scss',
})
export class EventCategory extends BaseCrudComponent<
  EventCategoryDto,
  EventCategoryCreateDto,
  EventCategoryUpdateDto,
  EventCategoryExcelDownloadDto
> {
  service = inject(EventCategoryService);
  config = EVENTCATEGORY_CONFIG;
  fields = EVENTCATEGORY_FIELDS;

  protected prepareUpdateDto(data: any, selected: EventCategoryDto): EventCategoryUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'EventCategory';
  }
}
